function urlName(name) {
	return name
		.trim()
		.toLowerCase()
		.replace(/\s/g,'-')
		.replace('é','e')
		.replace('á','a')
		.replace(/"/g,'')
		.replace('.','-')
		.replace('--','-')
		.replace('í', 'i')
		.replace('ë', 'e')
		;
}

module.exports = urlName;


// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/url-name.js